import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import Codepen from '../../helpers/Codepen';
// import { Button } from '../../base/Buttons'

const hashMap = {
  variables: "BmLOKR",
  variablesWithConsoleLog: "NwbjRE",
  variablesConstReassigned: "WXoOMx",
  arrays: "eeBRwM",
  objects: "eeBeqM",
  objectsCollection: "EbNoyG",
  objectsReassign: "JObMaj",
  ifElseStatement: "BmQGON",
  ifElseIfStatement: "BmQvKL",
  ternaryOperator: "VrPKOa",
  forLoop: "QOdGVo",
  whileLoop: "mqRWQr",
  doWhileLoop: "ooBZOX",
  logicalOperators: "EbZXxZ",

  basicFunction: "JOEOoJ",
  functionWithArgument: "qVRVNP",
  functionFavouriteMovies: "MOJOpe",
  arrayPushPop: "pdRpoP",
  arrayShiftUnshift: "xPgpGa",
  arrayNotModifying: "vWgdYX",
  functionFavouriteMoviesES6: "wPgyVR",
  multiplyByTwo: "mqRjRz",
  arrayMap: "LOxBOd",
  arrayFilter: "xPgymE",
  arrayReduce: "pdeEMV",
  arrayFind: "OOWwKP",
  arrayIncludes: "QOpzmd",
  arrayForEach: "ooBPXJ",
  arrayForEachNamed: "YENOGo",
  titlesToSlugs: "rYjZrq",
  titlesToSlugSolution: "POWdyb",
  functionFavouriteMoviesRefactored: "LOxgmb",
  functionFavouriteMoviesRefactoredSolution: "bYgmMx",

  // objects
  objectMethods: "mqWEXz",
  objectMethodsExtended: "eevdeM",
  objectCoersion: "rYyjKj",
  constructorFunction: "MOppmE",
  classes: "VrbKbq",
  subclasses: "rYyyXQ",
  movieWithSubtitles: "eevEZG",
  movieWithSubtitlesSolution: "bYqreE",

  // DOM's document
  movieClass: "WXjGKo",
  movieListOnClick: "ooWzJV",
  movieListOnClickBubbling: "rYmoPJ",
  movieListOnClickBubblingEventTarget: "eeWxbx",
  movieListPart1: "gXWmWN",
  movieListPart1Solution: "mqmmqr",
  movieListPart2: "qVmpWp",

  // React Introduction
  reactFirst: "9jnyx4zkyp",
  reactSecond: "oovwvz6q99",


  // React lifecycle
  arraySpread: "pdZgvJ",
}

const Wrapper = styled.div`
  width: 100%;
  margin-bottom: ${props => props.theme.margins.lg};
`;

const MainPanel = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

class CodepenBlock extends Component {
  static propTypes = {
    blockNumber: PropTypes.string,
    hash: PropTypes.string
  };

  render() {
    const { hash, blockNumber } = this.props;

    return (
      <Wrapper data-blocknumber={blockNumber} className='block'>
        <MainPanel>
          <Codepen hash={hashMap[`${hash}`]} />
        </MainPanel>
      </Wrapper>
    );
  }
}

export default CodepenBlock;



// WEBPACK FOOTER //
// ./src/book/blocks/CodepenBlock.js